import { useForm } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { DialogFooter } from '@/components/ui/dialog';
import type { CreateUserFormData } from '../types/company-admin.types';

interface FieldProps {
  register: ReturnType<typeof useForm<CreateUserFormData>>['register'];
  error?: { message?: string };
}

export function EmailField({ register, error }: FieldProps): React.JSX.Element {
  return (
    <div className="space-y-2">
      <Label htmlFor="email">Email</Label>
      <Input id="email" type="email" {...register('email')} />
      {error && <p className="text-sm text-destructive">{error.message}</p>}
    </div>
  );
}

export function PasswordField({ register, error }: FieldProps): React.JSX.Element {
  return (
    <div className="space-y-2">
      <Label htmlFor="password">Password</Label>
      <Input id="password" type="password" {...register('password')} />
      {error && <p className="text-sm text-destructive">{error.message}</p>}
    </div>
  );
}

export function FormFooter({
  isPending,
  onCancel,
}: {
  isPending: boolean;
  onCancel: () => void;
}): React.JSX.Element {
  return (
    <DialogFooter className="gap-2">
      <Button type="button" variant="outline" onClick={onCancel}>
        Cancel
      </Button>
      <Button type="submit" disabled={isPending}>
        {isPending ? 'Creating...' : 'Create'}
      </Button>
    </DialogFooter>
  );
}
